// @flow
import React, { Component, type Node } from 'react';
import { StripeProvider as LibStripeProvider, Elements } from 'react-stripe-elements';
import styled, { type StyledComponent } from 'styled-components';

import AnimatedSpinner from '@rover/react-lib/components/typography/AnimatedSpinner';
import { getStripeClient } from '@rover/utilities/stripe.client';

// NOTE(Ryan) the min-height here helps prevent the layout jumping too much while loading Stripe.js
export const StyledSpinner: StyledComponent<
  React$ElementConfig<typeof AnimatedSpinner>,
  {},
  any
> = styled(AnimatedSpinner)`
  min-height: 350px;
`;

export type Props = {
  apiKey: string,
  children: Node,
  onStripeLoaded: () => void,
  language: string,
};

export type State = {
  stripe: Object | null,
};

export default class StripeProvider extends Component<Props, State> {
  static defaultProps = {
    apiKey: '',
    onStripeLoaded: () => {},
  };

  state = {
    stripe: null,
  };

  async componentDidMount() {
    const stripeClient = await getStripeClient(this.props.apiKey);
    this.initStripe(stripeClient);
  }

  initStripe = (stripe: any) => {
    this.setState(() => ({ stripe }), this.props.onStripeLoaded);
  };

  render() {
    const { children, language } = this.props;
    const { stripe } = this.state;

    return (
      <LibStripeProvider stripe={stripe}>
        {stripe ? (
          <Elements locale={language} key={language}>
            {children}
          </Elements>
        ) : (
          <StyledSpinner />
        )}
      </LibStripeProvider>
    );
  }
}



// WEBPACK FOOTER //
// ../react-lib/src/components/utils/StripeProvider/StripeProvider.jsx